const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export const GetEmpresaContactes = async (idEmpresa: number) => {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas/${idEmpresa}/contactes`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        if (response.ok) {
            return await response.json();
        }
        return [];
    } catch (e) {
        console.error(e);
        return [];
    }
};

export const PostEmpresaContacte = async (idEmpresa: number, nom: string, email: string, telefon: string, carrec: string) => {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas/contactes`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ id_empresa: Number(idEmpresa), nom, email, telefon, carrec }),
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const DeleteEmpresaContacte = async (id: number) => {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas/contactes/${id}`, {
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
};

export const PutEmpresaContacte = async (id: number, nom: string, email: string, telefon: string, carrec: string) => {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas/contactes`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ id, nom, email, telefon, carrec }),
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
};
